import React, {
  Component
} from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom';
import './App.css';
import './css/style.min.css';
import Login from './components/Login/Login';
import Tier3 from './components/Pages/Tier3';
import MeManager from './components/Pages/MeManager';
import ProductionPlanning from './components/Pages/ProductionPlanning';
import Reports from './components/Pages/Reports';
import Registration from './components/Registration/Registration';
import ResetPassword from './components/ResetPassword/ResetPassword';
import ListUsers from './components/UserManagement/ListUsers';
import CreateUser from './components/UserManagement/CreateUser';
import EditUser from './components/UserManagement/EditUser';
import ListRoles from './components/RoleManagement/ListRoles';
import CreateRole from './components/RoleManagement/CreateRole';
import EditRole from './components/RoleManagement/EditRole';
import {
  isAuthenticated
} from './client/helpers/AuthHelper';
import {
  setClassLeftSidebar,
} from './client/helpers/LeftMenuHelper';
import {
  closeTopMenuDropdownIfOnClick
}
  from './client/helpers/Helper';
import {
  PublicRoute,
  PrivateRoute
} from './routes/Routes';
import {
  path_login,
  path_registration,
  path_reset_password,
  path_tier3,
  path_me_manager,
  path_production_planning,
  path_reports,
  path_users,
  path_create_user,
  path_edit_user,
  path_roles,
  path_create_role,
  path_edit_role
} from './routes/Pathnames';

class App extends Component {
  componentDidMount() {
    setClassLeftSidebar();
    closeTopMenuDropdownIfOnClick();
  }

  render() {
      return (
      <Router>
        <Switch>
          <PublicRoute path={path_login} component={Login} />
          <Route path={path_registration} render={() => (!isAuthenticated() ? <Registration/> : <Redirect to={{pathname: path_login}}/>)} />
          <PublicRoute path={path_reset_password} component={ResetPassword} />
          <PrivateRoute path="/" exact component={Tier3} />
          <PrivateRoute path={path_tier3} component={Tier3} />
          <PrivateRoute path={path_me_manager} component={MeManager} />
          <PrivateRoute path={path_production_planning} component={ProductionPlanning} />
          <PrivateRoute path={path_reports} component={Reports} />
          <PrivateRoute path={path_users} component={ListUsers} />
          <PrivateRoute path={path_create_user} component={CreateUser} />
          <PrivateRoute path={path_edit_user} component={EditUser} />
          <PrivateRoute path={path_roles} component={ListRoles} />
          <PrivateRoute path={path_create_role} component={CreateRole} />
          <PrivateRoute path={path_edit_role} component={EditRole} />
        </Switch>
      </Router>
    );
  }
}

export default App;
